// Notification Types Icons

import { ReactComponent as NewFeatureIcon } from '../assets/icons/notifications/icons-new-feature.svg';
import { ReactComponent as QuickTipIcon } from '../assets/icons/notifications/icons-quick-tip.svg';
import { ReactComponent as PromoIcon } from '../assets/icons/notifications/icons-promo.svg';
import { ReactComponent as PerformanceIcon } from '../assets/icons/notifications/icons-performance.svg';
import { ReactComponent as IntegrationIcon } from '../assets/icons/notifications/icons-integrations.svg';
import { ReactComponent as SecurityIcon } from '../assets/icons/notifications/icons-security.svg';

// Bell Icons

import { ReactComponent as Svg1 } from '../assets/icons/notifications/icon-notification-inactive-closed.svg';
import { ReactComponent as Svg2 } from '../assets/icons/notifications/icon-notification-inactive-closed-hover.svg';
import { ReactComponent as Svg3 } from '../assets/icons/notifications/icon-notification-inactive-open.svg';
import { ReactComponent as Svg4 } from '../assets/icons/notifications/icon-notification-inactive-open-hover.svg';
import { ReactComponent as Svg5 } from '../assets/icons/notifications/icon-notification-active-closed.svg';
import { ReactComponent as Svg6 } from '../assets/icons/notifications/icon-notification-active-closed-hover.svg';
import { ReactComponent as Svg7 } from '../assets/icons/notifications/icon-notification-active-open.svg';
import { ReactComponent as Svg8 } from '../assets/icons/notifications/icon-notification-active-open-hover.svg';

// Notification Drawer | Drop down Icons

import { ReactComponent as BULB } from "../assets/icons/notifications/light-bulb.svg"
import { ReactComponent as LINK } from "../assets/icons/notifications/link.svg"
import { ReactComponent as LOCK } from "../assets/icons/notifications/lock-closed.svg"
import { ReactComponent as ROCKET } from "../assets/icons/notifications/rocket-launch.svg"
import { ReactComponent as STAR } from "../assets/icons/notifications/star.svg"
import { ReactComponent as TAG } from "../assets/icons/notifications/tag.svg"


const notifications = [
    {
        title: "New Order Placed",
        description:
            "You have received a new order from John. Review the order details to ensure all requirements are met. Timely confirmation will improve your seller rating.",
        time: "2025-07-10T09:00:00Z",
        type: "New Feature",
        isRead: true,
    },
    {
        title: "Invoice Paid",
        description:
            "Invoice #145 was marked as paid. Funds will be transferred to your account within 2-3 business days. You can download the receipt from your billing section.",
        time: "2025-07-09T14:30:00Z",
        type: "Quick Tip",
        isRead: false,
    },
    {
        title: "Team Invite",
        description:
            "Sarah invited you to join the Design team. Accept the invitation to collaborate on ongoing projects and access shared resources and discussions.",
        time: "2025-07-08T12:15:00Z",
        type: "Promo",
        isRead: true,
    },
    {
        title: "Meeting Reminder",
        description:
            "Reminder: Project sync at 3 PM today. Join the Zoom call using the link provided in the calendar invite. Please come prepared with updates.",
        time: "2025-07-07T08:00:00Z",
        type: "Performance",
        isRead: false,
    },
    {
        title: "Security Alert",
        description:
            "Suspicious login attempt detected. Someone tried accessing your account from an unrecognized device. Please review your login history and update your password.",
        time: "2025-07-06T22:45:00Z",
        type: "Integration",
        isRead: false,
    },
    {
        title: "New Message",
        description:
            "Alex sent you a new message. Open your inbox to read and reply. Keeping communication timely helps ensure smooth progress on shared tasks.",
        time: "2025-07-06T18:10:00Z",
        type: "Security",
        isRead: true,
    },
];


const notificationTypeIcons = {
    newfeature: NewFeatureIcon,
    quicktip: QuickTipIcon,
    promo: PromoIcon,
    performance: PerformanceIcon,
    integrations: IntegrationIcon,
    security: SecurityIcon,
};



const notificationBellIcons = {
    svg1: Svg1,
    svg2: Svg2,
    svg3: Svg3,
    svg4: Svg4,
    svg5: Svg5,
    svg6: Svg6,
    svg7: Svg7,
    svg8: Svg8,
};

const NotificationDropDownIcon = {
    bulb: BULB,
    link: LINK,
    lock: LOCK,
    rocket: ROCKET,
    star: STAR,
    tag: TAG,
};

const notificationOptions = [
    { value: 'star', label: 'New Feature' },
    { value: 'bulb', label: 'Quick Tip' },
    { value: 'tag', label: 'Promo' },
    { value: 'rocket', label: 'Performance' },
    { value: 'link', label: 'Integrations' },
    { value: 'lock', label: 'Security' },
];

// Helper functions

function getNotificationIcon({ hasNotification, open, hovered }) {
    const stateKey = [
        hasNotification ? '1' : '0',
        open ? '1' : '0',
        hovered ? '1' : '0',
    ].join('');

    const iconMap = {
        '000': notificationBellIcons.svg1,
        '001': notificationBellIcons.svg2,
        '010': notificationBellIcons.svg3,
        '011': notificationBellIcons.svg4,
        '100': notificationBellIcons.svg5,
        '101': notificationBellIcons.svg6,
        '110': notificationBellIcons.svg7,
        '111': notificationBellIcons.svg8,
    };

    return iconMap[stateKey] || notificationBellIcons.svg1;
}

function formatToDayTime(isoString) {
    const date = new Date(isoString);
    const weekday = date.toLocaleDateString('en-US', { weekday: 'long' });

    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12 || 12;

    return `${weekday} ${hours}:${minutes}${ampm}`;
}

const normalizeTypeName = (name) =>
    name.toLowerCase().replace(/\s+/g, '');

const validateLink = (str) => {
    const trimmed = str.trim();
    if (!trimmed) return '';

    // Must start with https://
    if (!/^https:\/\//i.test(trimmed)) {
        return 'Link must start with https://';
    }

    if (/\s|,/.test(trimmed)) {
        return 'Only one link allowed (no spaces or commas).';
    }

    try {
        new URL(trimmed);
        return '';
    } catch (_) {
        return 'Invalid URL format.';
    }
};

export {
    notifications,
    notificationTypeIcons,
    notificationBellIcons,
    getNotificationIcon,
    formatToDayTime,
    normalizeTypeName,
    NotificationDropDownIcon,
    notificationOptions,
    validateLink
}
